var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 px-0 d-flex align-items-center return",on:{"click":function($event){return _vm.goToPreviousPage()}}},[_c('font-awesome-icon',{staticClass:"return-icon mr-2",attrs:{"icon":['fas', 'long-arrow-left']}}),_c('p',{staticClass:"mb-0 return-text"},[_vm._v("Retour")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }